import React from "react";
import { AlertTriangle } from "lucide-react";

interface DeleteGroupModalProps {
  isOpen: boolean;
  onClose: () => void;
  deletingGroup: any;
  onConfirmDelete: () => void;
}

const DeleteGroupModal: React.FC<DeleteGroupModalProps> = ({
  isOpen,
  onClose,
  deletingGroup,
  onConfirmDelete,
}) => {
  if (!isOpen || !deletingGroup) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4">
        <div className="flex items-center mb-4">
          <AlertTriangle className="h-6 w-6 text-red-600 mr-3" />
          <h3 className="text-lg font-medium text-gray-900">Delete Group</h3>
        </div>

        <p className="text-gray-600 mb-6">
          Are you sure you want to delete the group "{deletingGroup.name}"? This
          action cannot be undone.
        </p>

        <div className="flex items-center justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={onConfirmDelete}
            className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteGroupModal;
